module.exports = __webpack_public_path__ + "6ae82ea2c6dd6c1437a07ea08e63a491.pdf";